module.exports = __webpack_public_path__ + "img/185.8e414763.jpg";